import type { GetFullRegisterResponse } from './types';

import { getGenericEndpoint } from './get.api';

export const getFullRegister = async (lang?: string) => {
    return await getGenericEndpoint<GetFullRegisterResponse>('register/full', lang);
};
